var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9213 28.1771C24.0698 30.5609 20.3708 32 16.3288 32C7.31064 32 0 24.8366 0 16C0 7.16344 7.31064 0 16.3288 0C20.3708 0 24.0698 1.4391 26.9213 3.82293C29.7727 1.4391 33.4718 0 37.5138 0C46.5319 0 53.8426 7.16344 53.8426 16C53.8426 24.8366 46.5319 32 37.5138 32C33.4718 32 29.7727 30.5609 26.9213 28.1771Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9189 28.1766C30.429 25.2419 32.6546 20.8756 32.6546 16C32.6546 11.1244 30.429 6.75808 26.9189 3.82339C29.7705 1.43929 33.4697 0 37.512 0C46.5302 0 53.8408 7.16344 53.8408 16C53.8408 24.8366 46.5302 32 37.512 32C33.4697 32 29.7705 30.5607 26.9189 28.1766Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9218 28.177C30.4322 25.2423 32.658 20.8759 32.658 16C32.658 11.1241 30.4322 6.75757 26.9218 3.82288C23.4114 6.75757 21.1855 11.1241 21.1855 16C21.1855 20.8759 23.4114 25.2423 26.9218 28.177Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank2);
export default __webpack_public_path__ + "static/media/bank2.d12472d3fbb0613127e3a46b4fb90e27.svg";
export { ForwardRef as ReactComponent };